export const TYPES_REQUEST = "Types.Request";
export const TYPES_SUCCESS = "Types.Success";
export const TYPES_FAILURE = "Types.Failure";
export const TYPES_RESET = "Types.Reset";


export function getTypes() {
  return (dispatch, getState) => {
    const { auth } = getState();
    if (auth?.token) {
      dispatch({ type: TYPES_REQUEST });
      return fetch("/api/document-types", {
        headers: { Authorization: `Bearer ${auth.token}` },
      }).then(async (response) => {
        const data = await response.json();
        if (data.status === "success") {
          dispatch({
            type: TYPES_SUCCESS,
            payload: data.result,
          });
        } else {
          dispatch({ type: TYPES_FAILURE });
        }
      }).catch(() => {
        dispatch({ type: TYPES_FAILURE });
      });
    } else {
      dispatch({ type: TYPES_FAILURE });
    }
  };
}


export const TYPES_EDIT_REQUEST = "TypesEdit.Request";
export const TYPES_EDIT_SUCCESS = "TypesEdit.Success";
export const TYPES_EDIT_FAILURE = "TypesEdit.Failure";
export const TYPES_EDIT_RESET = "TypesEdit.Reset";



export function editTypes(id:string, data:any) {
  return (dispatch, getState) => {
    const { auth } = getState();
    if (auth?.token) {
      dispatch({ type: TYPES_EDIT_REQUEST });
      return fetch(`/api/document-types/${id}`, {
        method: "PATCH",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then(async (response) => {
        const data = await response.json();
        if (data.status === "success") {
          dispatch({
            type: TYPES_EDIT_SUCCESS,
            payload: data.result,
          });
        } else {
          dispatch({ type: TYPES_EDIT_FAILURE, payload: data  });
        }
      }).catch(() => {
        dispatch({ type: TYPES_EDIT_FAILURE,  payload: data });
      });
    } 
  };
}

